/*
 * File: LocalitySelector.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 3:23 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


/**
 * Styles
 */

export const Wrapper = styled.div`
	position: relative;
	background-color: ${({ theme }) => theme.neutralButton};
    padding: 12px;
    border-radius: 20px;
    width: 100%;

	${({ $forceCompact }) => !$forceCompact && css`
		@media only screen and (min-width: 40em) {
			padding: 12px 12px 12px 30px;
			width: auto;
			border-radius: 29px;
		}
	`}
`;

export const LocalitySelectorContainer = styled.div`
	position: relative;
    display: flex;
    align-items: start;
    flex-direction: column;
	margin: 0px;
    gap: 8px;

	& > p {
		font-weight: 600;
		margin: 0px 0px 0px 14px;
		font-size: 0.9rem;
	}
	${({ $forceCompact }) => !$forceCompact && css`
		@media only screen and (min-width: 40em) {
			flex-direction: row;
        	align-items: center;
        	gap: 15px;

			& > p {
				margin: 0px;
			}
		}
	`};
`;

export const CountrySelector = styled.div`
	background-color: ${({ theme }) => theme.surfaceBackground};
	cursor: pointer;
	position: relative;
	height: 34px;
	border-radius: 17px;
	padding: 0px 12px 0px 16px;
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 190px;
	border: 1px solid ${({ theme }) => theme.surfaceBackground};

	& > span {
		flex-grow: 1;
		color: ${({ theme }) => theme.primaryText};
		font-weight: 600;
		font-size: 0.9rem;
	}
`;

export const LanguageSelector = styled.div`
	background-color: ${({ theme }) => theme.surfaceBackground};
	cursor: pointer;
	position: relative;
	height: 34px;
	border-radius: 17px;
	padding: 0px 12px 0px 16px;
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 140px;
	border: 1px solid ${({ theme }) => theme.surfaceBackground};

	& > span {
		flex-grow: 1;
		color: ${({ theme }) => theme.primaryText};
		font-weight: 600;
		font-size: 0.9rem;
	}
`;

export const Dropdown = styled.div`
	position: absolute;
	height: auto !important;
	z-index: 99;
	background-color: ${({ theme }) => theme.surfaceBackground};
	border-radius: 17px;
	opacity: 0;
	visibility: hidden;
	transform: scale(1.05);
	transition: visibility 0s linear 0.3s, opacity 0.3s 0s, transform 0.3s;
	pointer-events: none;
	padding: 10px 16px 20px;
	display: flex;
	flex-direction: column;
	gap: 14px;
	width: 100%;
	max-height: 217px;
	overflow: scroll;
	border-left: 1px solid ${({ theme }) => theme.layoutBorder};
	border-right: 1px solid ${({ theme }) => theme.layoutBorder};
	border-bottom: 1px solid ${({ theme }) => theme.layoutBorder};

	a,
	a:link,
	a:visited {
		display: flex;
		letter-spacing: normal;
		gap: 8px;
		align-items: center;

		span {
			color: ${({ theme }) => theme.primaryText};
			font-weight: 500;
			font-size: 0.9rem;
		}
		&:hover span {
			text-decoration: underline;
		}
	}
`;

export const DropdownRow = styled.div`
	display: flex;
	letter-spacing: normal;
	gap: 8px;
	align-items: center;
	cursor: pointer;

	span {
		color: ${({ theme }) => theme.primaryText};
		font-weight: 500;
		font-size: 0.9rem;
	}
	&:hover span {
		text-decoration: underline;
	}
`;

export const FlagImg = styled.img`
	width: 22px;
	height: 12px;
	border-radius: 1px;
`;

export const PrimaryIcon = styled(FontAwesomeIcon)`
	color: ${({ theme }) => theme.primaryDecoration};
	font-size: 1.2rem;
`;

export const SecondaryIcon = styled(FontAwesomeIcon)`
	color: ${({ theme }) => theme.primaryDecoration};
	font-size: 0.85rem;
	margin-left: 8px;
`;

export const LocalitySelector = styled.div`
	position: relative;
	width: 100%;

	${({ $forceCompact }) => !$forceCompact && css`
		@media only screen and (min-width: 40em) {
			width: auto;
		}
	`};
	&:hover {
		${SecondaryIcon} {
			transform: rotate(180deg);
		}
		${Dropdown} {
			opacity: 1;
			visibility: visible;
			transform: scale(1);
			transition: visibility 0s linear 0s, opacity 0.3s 0s, transform 0.3s;
			pointer-events: all;
			border-radius: 0px 0px 17px 17px;
		}
		${CountrySelector} {
			border-radius: 17px 17px 0px 0px;
			border-top: 1px solid ${({ theme }) => theme.layoutBorder};
			border-left: 1px solid ${({ theme }) => theme.layoutBorder};
			border-right: 1px solid ${({ theme }) => theme.layoutBorder};
		}
		${LanguageSelector} {
			border-radius: 17px 17px 0px 0px;
			border-top: 1px solid ${({ theme }) => theme.layoutBorder};
			border-left: 1px solid ${({ theme }) => theme.layoutBorder};
			border-right: 1px solid ${({ theme }) => theme.layoutBorder};
		}
	}
`;
